import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user clicks on the upsell from the credit meter to view the plans modal or talk to sales',
  name: 'credit_meter_upsell_clicked',
  params: [
    {
      description: 'Percentage of credits used',
      name: 'pct_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
